import React, { useState } from "react";
import { FaWhatsapp, FaPhone, FaTimes, FaComments } from "react-icons/fa";

const FloatingWhatsAppButton = () => {
  const [showPopup, setShowPopup] = useState(false);
  const whatsappNumber = "+918374249705";
  const phoneNumber = "+918331905506";
  const whatsappMessage = "Hello! I'm interested in your real estate projects.";
  const whatsappURL = `https://wa.me/${whatsappNumber.replace(/\D/g, "")}?text=${encodeURIComponent(
    whatsappMessage
  )}`;

  return (
    <>
      {/* Floating Button */}
      <button
        onClick={() => setShowPopup(!showPopup)}
        className="fixed bottom-6 right-6 bg-red-900 hover:bg-red-950 text-white p-4 rounded-full shadow-lg transition-all duration-300 z-50 flex items-center justify-center"
        title="Contact us"
      >
        <FaComments className="text-2xl" />
      </button>

      {/* Popup Menu */}
      {showPopup && (
        <div className="fixed bottom-24 right-6 bg-white rounded-lg shadow-2xl p-4 z-50 w-56 animate-in fade-in slide-in-from-bottom-2">
          {/* Close Button */}
          <button
            onClick={() => setShowPopup(false)}
            className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-xl"
          >
            <FaTimes />
          </button>

          <h3 className="font-bold text-gray-800 mb-4 pr-6">Contact Us</h3>

          {/* WhatsApp Option */}
          <a
            href={whatsappURL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 w-full p-3 rounded-lg hover:bg-green-50 transition mb-2 text-green-600 hover:text-green-700"
            onClick={() => setShowPopup(false)}
          >
            <FaWhatsapp className="text-xl" />
            <div className="text-left">
              <p className="font-semibold text-sm">WhatsApp Message</p>
              <p className="text-xs text-gray-600">+91 8374249705</p>
            </div>
          </a>

          {/* Call Option */}
          <a
            href={`tel:${phoneNumber}`}
            className="flex items-center gap-3 w-full p-3 rounded-lg hover:bg-blue-50 transition text-blue-600 hover:text-blue-700"
            onClick={() => setShowPopup(false)}
          >
            <FaPhone className="text-xl" />
            <div className="text-left">
              <p className="font-semibold text-sm">Call Us</p>
              <p className="text-xs text-gray-600">+91 8331905506</p>
            </div>
          </a>
        </div>
      )}
    </>
  );
};

export default FloatingWhatsAppButton;
